import { calcStackedColumnBarOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/stackedColumnBarConfig'

export const calcStackedColumnOptions = props => {
  const result = calcStackedColumnBarOptions(props)
  if (!result) return null

  result.options.chart.type = 'column'
  result.options.chart.defaultSeriesType = 'column'
  result.options.plotOptions.column = { groupPadding: 0.05 }

  return result
}
